export enum TipoDocumento {
  EXCEL = 'EXCEL',
  PDF = 'PDF'
}
